export default function keyGenerator(
  applicationId: string,
  persistStoreId: string,
  namespace: string,
): string {
  return `${applicationId}-${persistStoreId}-${namespace}`;
}
